import { Flex, Stack } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { usePermissionsContext } from "#app/PermissionsProvider";
import { colors } from "#app/theme/v2/colors";
import { spacing } from "#app/theme/v2/spacing";
import { Text } from "#components/atoms/Typographies/Text";
import { Title } from "#components/atoms/Typographies/Title";
import { useCompleteOnboarding } from "#modules/company/view/useCompleteOnboarding";
import { OnboardingV2Shell } from "#modules/onboardingV2/view/OnboardingV2Shell";
import { useTrackOnboardingStepViewed } from "#modules/onboardingV2/view/useOnboardingAnalytics";
import { useUser } from "#modules/users/view/useUser";
import { Icon } from "#shared/icons/Icon";
import { ROUTES } from "#shared/routes";
import { AnalyticsEvent, useAnalytics } from "#shared/useAnalytics";

export const OnboardingFinishStepPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const analytics = useAnalytics();
  const { user } = useUser();
  const { completeOnboarding } = useCompleteOnboarding({
    onSuccess: () => {
      analytics.capture(AnalyticsEvent.OnboardingCompleted, {
        companyId: user?.companyId,
        userId: user?.id,
        onboardingVersion: "v2",
      });
    },
  });

  useTrackOnboardingStepViewed("finish");
  const { webInterfaceV2 } = usePermissionsContext();

  const handleContinue = () => {
    void completeOnboarding();
    if (webInterfaceV2) {
      navigate(ROUTES.v2);
    } else {
      navigate(ROUTES.partner);
    }
  };

  return (
    <OnboardingV2Shell size="sm">
      <OnboardingV2Shell.Content>
        <Stack align="center" gap={spacing[12]}>
          <Stack align="center" gap={spacing[5]}>
            <Flex
              justify="center"
              align="center"
              w={spacing[16]}
              h={spacing[16]}
              style={{
                backgroundColor: colors.bg.status.success.primary,
                borderRadius: "50%",
              }}
            >
              <Icon name="check" size={32} color={colors.icon.success} />
            </Flex>
            <Stack align="center" gap={spacing[4]} maw={560}>
              <Title size="large" style={{ textAlign: "center" }}>
                {t("onboardingV2.finish.title")}
              </Title>
              <Text color={colors.text.secondaryDefault} textAlign="center">
                {t("onboardingV2.finish.subtitle")}
              </Text>
            </Stack>
          </Stack>
        </Stack>
      </OnboardingV2Shell.Content>

      <OnboardingV2Shell.Footer
        buttonLabel={t("onboardingV2.finish.cta")}
        onContinue={handleContinue}
      />
    </OnboardingV2Shell>
  );
};
